const SOURCE_PORTAL_PREFIX = 'source_portal_from_';
const TO_PREFIX = '_to_';

/**
 * Returns true when `id` is a FlowBuilder "source portal" virtual node id.
 * Use this instead of raw `id.startsWith('source_portal')` so the magic
 * prefix lives in exactly one place.
 */
export const isSourcePortalId = (id: string): boolean =>
  id.startsWith(SOURCE_PORTAL_PREFIX);

/**
 * Extract the `targetId` from a FlowBuilder "source portal" node id.
 *
 * Expected shape:
 * `source_portal_from_${sourceId}_to_${targetId}_${sourceHandle || ''}`
 *
 * Returns `null` when the id is not a source-portal id or the format is malformed.
 */
const getTargetIdFromSourcePortal = (portalId: string): string | null => {
  if (!portalId.startsWith(SOURCE_PORTAL_PREFIX)) return null;

  const withoutPrefix = portalId.replace(SOURCE_PORTAL_PREFIX, '');
  const parts = withoutPrefix.split(TO_PREFIX);
  if (parts.length !== 2) return null;

  // `${targetId}_${sourceHandle || ''}`
  const rest = parts[1];
  const lastUnderscore = rest.lastIndexOf('_');
  if (lastUnderscore === -1) return null;

  const targetId = rest.slice(0, lastUnderscore);
  return targetId || null;
};

export default getTargetIdFromSourcePortal;
